import QualityControlRoutes from "./complaints";

export default [
  ...QualityControlRoutes,
];
